import React from 'react';
import { useTranslation } from 'react-i18next';
import filledImg from '@/assets/images/filled.webp';
import { Button } from '@/components/Button';
import { BorderRadius, ButtonVariant } from '@/types/components';

interface Props {
  onBack: () => void;
  onSubmit: () => void;
}

export const SurveySubmitConfirm: React.FC<Props> = ({ onBack, onSubmit }) => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-2 px-5 pb-16 text-center">
      <img
        src={filledImg}
        alt=""
        width={120}
        height={120}
        className="size-[120px]"
      />

      <p className="text-callout-16 text-foreground">
        {t('mail.surveys.detail.fill.submitTitle')}
      </p>
      <p className="text-body-14 max-w-[480px] text-subtle-foreground">
        {t('mail.surveys.detail.fill.submitSubtitle')}
      </p>

      <div className="mt-2 flex items-center gap-3">
        <Button
          variant={ButtonVariant.Secondary}
          radius={BorderRadius.Pill}
          onClick={onBack}
        >
          {t('mail.surveys.detail.fill.back')}
        </Button>
        <Button
          variant={ButtonVariant.Primary}
          radius={BorderRadius.Pill}
          onClick={onSubmit}
        >
          {t('mail.surveys.detail.fill.submit')}
        </Button>
      </div>
    </div>
  );
};
